import React from 'react';
import { useResponsive } from 'hooks/useResponsive';
import * as S from './BloodScreeningTable.styles';
import { BloodTestResult } from '@app/constants/bloodTestResults';
import { ColumnsType } from 'antd/es/table';

interface IBloodScreeningCardProps {
  ActiveItem: string;
  // eslint-disable-next-line
  rawData: any;
}

export const BloodScreeningTable: React.FC<IBloodScreeningCardProps> = ({ ActiveItem, rawData }) => {
  const { isTablet, isDesktop } = useResponsive();

  const filteredData = rawData
    // eslint-disable-next-line
    .filter((item: any) => item.Type === ActiveItem);

  const columns: ColumnsType<BloodTestResult> = [
    {
      title: 'Id',
      dataIndex: 'EmployeeUniqueId',
    },
    {
      title: 'Name',
      dataIndex: 'EmployeeName',
    },
    {
      title: 'Type',
      dataIndex: 'Type',
    },
    {
      title: 'E-Date',
      dataIndex: 'ExpiryDate',
    },
    {
      title: 'E-Days',
      dataIndex: 'ExpiryDays',
      render: (text) => <span style={{ color: Number(text) > 0 ? 'green' : 'red' }}>{text}</span>,
    },
  ];

  return (
    <S.Table
      size={'small'}
      pagination={false}
      columns={columns}
      dataSource={filteredData.length > 0 ? filteredData : rawData}
      scroll={{ y: isDesktop ? 300 : isTablet ? 620 : 400 }}
    />
  );
};
